import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { clientSettings } from 'go-modules/models/common/client.settings';
import { Observable } from 'rxjs';
import type { LlmFeatures, LlmRelations, LlmTask, LlmTaskStatus } from '@go-modules/interfaces/llm-task';
import type { BaseMarker } from '@go-modules/interfaces/markers/marker';

export interface LlmTaskGetStatusResponse {
	status: LlmTaskStatus;
	llm_tasks: LlmTask[];
}

export interface ImprovedCommentResponse {
	comment: string;
	llm_task_id: number;
}

@Injectable({
	providedIn: 'root'
})
export class LlmTaskService {
	constructor (private http: HttpClient) {}

	public getStatus (
		relatedType: LlmRelations,
		relatedId: number,
		feature?: LlmFeatures
	): Observable<LlmTaskGetStatusResponse> {
		let params = new HttpParams();

		if (feature) {
			params = params.set('feature', feature);
		}

		return this.http.get<LlmTaskGetStatusResponse>(`${clientSettings.GoReactV2API}/llm-tasks/type/${relatedType}/id/${relatedId}`, { params });
	}

	public getImprovedComment (
		originalComment: string,
		tagsList: BaseMarker[],
		sessionId: number,
		time: string
	): Observable<ImprovedCommentResponse> {
		return this.http.post<ImprovedCommentResponse>(`${clientSettings.GoReactV2API}/submissions/${sessionId}/comments/improve`, {
			text: originalComment,
			tag_ids: tagsList.map((tag) => tag.tag_id),
			time
		});
	}
}
